module.exports = __webpack_public_path__ + "static/media/php.59446ad2.png";